import styled from '@emotion/styled';

export const ContentSection = styled.section`
  width: 100%;
  max-width: calc(100% - 64px);
  height: calc(100vh);
  max-height: 1100px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  background: #ffffff;
  padding: 32px;
  margin: 32px auto;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  position: relative;
`;

export const Header = styled.header`
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  color: #6A42F2;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 0;
  margin-bottom: 16px;
  transition: all 0.2s ease;
  
  &:hover {
    color: #5936e8;
    text-decoration: underline;
  }
`;

export const ReportTitle = styled.h1`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 28px;
  line-height: 36px;
  font-weight: 700;
  margin: 0 0 12px 0;
`;

export const ReportDescription = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin: 0;
`;

// 🆕 보고서 제목 입력 관련 스타일 추가
export const ReportTitleSection = styled.div`
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
`;

export const ReportTitleLabel = styled.label`
  display: block;
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const ReportTitleInput = styled.input`
  width: 100%;
  max-width: 600px;
  height: 44px;
  border-radius: 6px;
  background: ${({ disabled }) => disabled ? '#f9fafb' : '#ffffff'};
  border: 1px solid #dddddd;
  padding: 12px 16px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${({ disabled }) => disabled ? '#9ca3af' : '#000000'};
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'text'};
  
  &:focus:not(:disabled) {
    outline: none;
    border-color: #6A42F2;
  }
  
  &::placeholder {
    color: #999999;
  }
`;

export const GeneratingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  z-index: 100;
`;

export const GeneratingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 400px;
`;

export const GeneratingSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top: 4px solid #6A42F2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 24px;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const GeneratingText = styled.div`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  line-height: 28px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const GeneratingSubtext = styled.div`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
`;